/**
 * otplib-hotp
 *
 * @author Gerald Yeo <contact@fusedthought.com>
 * @version: 9.0.0
 * @license: MIT
 **/
'use strict';

var _classCallCheck = require("/Users/stefan/git/ginlo/ginlo-backend/ginlo-cockpit/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/Users/stefan/git/ginlo/ginlo-backend/ginlo-cockpit/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var otplibCore = require('./core');
var HOTP = /*#__PURE__*/function () {
  function HOTP() {
    _classCallCheck(this, HOTP);
    this._options = this.defaultOptions;
  }
  _createClass(HOTP, [{
    key: "resetOptions",
    value: function resetOptions() {
      this._options = this.defaultOptions;
      return this;
    }
  }, {
    key: "generate",
    value: function generate(secret, counter) {
      var opt = this.optionsAll;
      return otplibCore.hotpToken(secret || opt.secret, counter, opt);
    }
  }, {
    key: "check",
    value: function check(token, secret, counter) {
      var opt = this.optionsAll;
      return otplibCore.hotpCheck(token, secret || opt.secret, counter, opt);
    }
  }, {
    key: "verify",
    value: function verify(opts) {
      if (typeof opts !== 'object' || opts == null) {
        return false;
      }
      return this.check(opts.token, opts.secret, opts.counter);
    }
  }, {
    key: "defaultOptions",
    get: function get() {
      return {};
    }
  }, {
    key: "options",
    set: function set() {
      var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (opt) {
        this._options = _extends({}, this._options, opt);
      }
    },
    get: function get() {
      return _extends({}, this._options);
    }
  }, {
    key: "optionsAll",
    get: function get() {
      return otplibCore.hotpOptions(this._options);
    }
  }]);
  return HOTP;
}();
HOTP.prototype.HOTP = HOTP;
var index = new HOTP();
module.exports = index;